import {
  getDatabaseContainerType,
  getSelectionsExperimentAttributes,
  useAnalytics as getAnalyticsClient,
} from '@databases/analytics';
import { appStore } from '@databases/redux/store';
import { doFillValues } from '@databases/redux/table-layout/actions';
import { createApplyFillEffect } from '@databases/selections';
import { getService } from '@databases/service-container';

import { type SelectionEffectFeature, SelectionFeatureKeys } from '../../features/types';

export function createApplyFillEffectFeature(deps: {
  contentId: string;
}): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.FILL_EFFECT,
    type: 'effect',
    isEnabled: (ctx) => ctx.permissions.canEditContent,
    factory: () => {
      const selectionsApi = getService('SelectionsApi');
      const analyticsClient = getAnalyticsClient();

      return createApplyFillEffect({
        resolveRangeToIds: (r) => selectionsApi.resolveRangeToIds(r),
        onSelectFilledValues: (values) => {
          selectionsApi.selectValues(values);
        },
        onFillValues: (params: {
          fillEntryIds: string[];
          fillFieldIds: string[];
          sourceEntryIds: string[];
          sourceFieldIds: string[];
        }) => {
          appStore.dispatch(
            doFillValues(
              deps.contentId,
              params.fillFieldIds,
              params.fillEntryIds,
              params.sourceEntryIds,
              params.sourceFieldIds
            )
          );

          void analyticsClient?.sendDragToFillAppliedEvent({
            contentId: deps.contentId,
            databaseContainer: getDatabaseContainerType(),
            ...getSelectionsExperimentAttributes(deps.contentId),
          });
        },
      });
    },
  };
}
